export default "__VITE_ASSET__92075dcc__"